import React, {useEffect, useState} from "react";
import {Helmet} from "react-helmet";
import {useDispatch} from "react-redux";
import {LoaderHide, LoaderShow} from "../../Store/Actions/Loader";
import Api from "../../API/api";
import {showToast} from "../../Store/Actions/ToastAction";
import {Input} from "../../UI/Input";
import {Button} from "../../UI/Button";

export const Avatars = () => {
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = useState(false)
  const [avatars, setAvatars] = useState([])
  const [openUrl, setOpenUrl] = useState(null)
  const [deleteModal, setDeleteModal] = useState(false)
  const [avatarId, setAvatarId] = useState(null)

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) {
        setModalShow(false)
      }
    };
    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, []);

  useEffect(() => {
    getAvatars()
  }, [])

  const getAvatars = () => {
    dispatch(LoaderShow())
    Api.getData('avatar', localStorage.getItem('userToken'))
      .then(res => {
        setAvatars(res.data)
        dispatch(LoaderHide())
      })
      .catch((err) => {
        dispatch(LoaderHide())
      })
  }

  const renderAvatars = () => {
    return avatars.map(item => (
      <div key={item?.id} className="avatars__list-item">
        <div className='avatars__list-img'><img
          src={item?.url} alt=""/></div>
        <div className="avatars__list-btns">
          <div onClick={() => {
            setOpenUrl(item?.url)
            setModalShow(true)
          }} className="avatars__list-btn"><img src="/assets/icons/eye.svg" alt="trash"/></div>
          <div onClick={() => {openDeleteModal(item.id)}} className="avatars__list-btn"><img src="/assets/icons/trash.svg" alt="trash"/></div>
        </div>
      </div>
    ))
  }

  const addFile = (e) => {
    if(e.target.files[0] !== undefined) {
      let formData = new FormData()
      formData.append('avatar', e.target.files[0])
      dispatch(LoaderShow())
      Api.postData('avatar', formData, localStorage.getItem('userToken'))
        .then(() => {
          dispatch(LoaderHide())
          getAvatars()
          dispatch(showToast({
            title: "Avatars",
            text: 'Avatar successfully added',
            type: "success",
          }))
        })
        .catch(err => {
          dispatch(LoaderHide())
          dispatch(showToast({
            title: "Avatars",
            text: err.response.data,
            type: "error",
          }))
        })
    }
  }

  const openDeleteModal = (id) => {
    setDeleteModal(true)
    setAvatarId(id)
  }

  const closeDeleteModal = () => {
    setDeleteModal(false)
    setAvatarId('')
  }

  const deleteAvatar = () => {
    dispatch(LoaderShow())
    Api.delete(`avatar/${avatarId}`, {}, localStorage.getItem('userToken'))
      .then(() => {
        dispatch(LoaderHide())
        closeDeleteModal()
        getAvatars()
        dispatch(showToast({
          title: "Avatars",
          text: 'Avatar successfully deleted',
          type: "success",
        }))
      })
      .catch(err => {
        dispatch(LoaderHide())
        dispatch(showToast({
          title: "Avatars",
          text: err.response.data,
          type: "error",
        }))
      })
  }

  return (
    <>
      {deleteModal && (<div className="modal">
        <div className="modal__content words__modal">
          <div className="words__modal-head">
            <p className="words__modal-title">Delete Avatar</p>
            <p className="words__modal-text">You are going to delete this avatar, are you sure?</p>
            <div onClick={() => {
              closeDeleteModal()
            }} className="modal__close"><img src="/assets/icons/close.svg" alt=""/></div>
          </div>
          <div className="modal__btns">
            <div className="words__modal-btn">
              <Button text="Cancel" type={'gray'} action={closeDeleteModal} />
            </div>
            <div className="words__modal-btn">
              <Button text="Delete" action={deleteAvatar} />
            </div>
          </div>
        </div>
        <div onClick={
          () => {
            closeDeleteModal()
          }} className="modal__bg"></div>
      </div>)}
      {modalShow && (<div className='modal'>
        <div className="modal__content">
          <div onClick={() => {setModalShow(false)}} className="modal__close"><img src="/assets/icons/close.svg" alt=""/></div>
          <img className="image" src={openUrl} alt=""/>
        </div>
        <div onClick={() => {setModalShow(false)}} className="modal__bg"></div>
      </div>)}
      <div className='page'>
        <Helmet>
          <meta charSet="utf-8"/>
          <title>SARK ADMIN | AVATARS</title>
        </Helmet>
        <div className="avatars container">
          <div className="avatars__head">
            <p className="users__title">Avatars <span>Total: {avatars.length} avatar(s)</span></p>
            <div className="avatars__btn">
              <label htmlFor="file">Add avatar</label>
              <input onChange={(e) => {addFile(e)}} id='file' className='avatars__file' type="file" accept="image/*"/>
            </div>
          </div>
          <div className="avatars__list">
            {renderAvatars()}
          </div>
        </div>
      </div>
    </>
  )
}
